import React, { useEffect } from 'react';

export default function EndSessionModal({ room, onConfirm, onCancel }) {

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onCancel]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-5"
      style={{ backgroundColor: 'rgba(0,0,0,0.80)', backdropFilter: 'blur(14px)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div
        className="w-full max-w-xs rounded-2xl border border-[#242424] flex flex-col overflow-hidden"
        style={{ backgroundColor: '#0e0e0e' }}
      >
        {/* ── Content ── */}
        <div className="px-7 pt-7 pb-6 flex flex-col gap-2">
          <h2 className="text-sm font-bold text-white tracking-wide">
            End session in {room}?
          </h2>
          <p className="text-xs leading-relaxed" style={{ color: '#666666' }}>
            The timer will reset and the session will be cleared.
          </p>
        </div>

        {/* ── Actions ── */}
        <div className="px-7 pb-7 flex gap-3">
          <button
            onClick={onCancel}
            className="
              flex-1 min-h-[48px] py-3 rounded-xl text-sm font-bold
              bg-white text-black hover:bg-[#e8e8e8]
              transition-all duration-150 active:scale-[0.99]
            "
          >
            Keep Going
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 min-h-[48px] py-3 rounded-xl text-sm font-bold border transition-all duration-200 active:scale-[0.99]"
            style={{
              backgroundColor: 'rgba(140,28,28,0.10)',
              borderColor:     'rgba(140,28,28,0.30)',
              color:           '#cc4444',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(140,28,28,0.20)';
              e.currentTarget.style.borderColor     = 'rgba(140,28,28,0.55)';
              e.currentTarget.style.color           = '#e05555';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(140,28,28,0.10)';
              e.currentTarget.style.borderColor     = 'rgba(140,28,28,0.30)';
              e.currentTarget.style.color           = '#cc4444';
            }}
          >
            End Session
          </button>
        </div>
      </div>
    </div>
  );
}